(function () {
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function toStorePath(url) {
    if (!url) return '';
    var u = String(url);
    if (u.indexOf('https://ironspearoutfitters.com/') === 0) {
      return u.slice('https://ironspearoutfitters.com'.length) || '/';
    }
    if (u.indexOf('http://ironspearoutfitters.com/') === 0) {
      return u.slice('http://ironspearoutfitters.com'.length) || '/';
    }
    return u;
  }

  function initRoot(root) {
    var cfgEl = document.querySelector('script[type="application/json"][data-adapter-config]');
    var cfg = {};
    try {
      cfg = cfgEl ? JSON.parse(cfgEl.textContent || '{}') : {};
    } catch (e) {
      cfg = {};
    }
    var dataUrl = cfg.dataUrl;
    var scheme = 'scheme-3';
    var search = root.querySelector('[data-adapter-search]');
    var grid = root.querySelector('[data-adapter-grid]');
    var countEl = root.querySelector('[data-adapter-count]');
    var emptyEl = root.querySelector('[data-adapter-empty]');
    var totalEl = root.querySelector('[data-adapter-total]');
    if (!dataUrl || !grid || !search) return;

    fetch(dataUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('adapter data HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var radios = (data && data.radios) || [];
        if (totalEl) totalEl.textContent = String(radios.length);

        var html = radios
          .map(function (r) {
            var brand = r.brand || '';
            var model = r.model || '';
            var connector = r.connector || '';
            var adapter = r.adapter || '';
            var url = toStorePath(r.url || '');
            var note = r.note || '';
            var image = r.image || '';
            var imageAlt = r.imageAlt || brand + ' ' + model + ' handheld radio';
            var hay = (brand + ' ' + model + ' ' + connector + ' ' + adapter + ' ' + note).toLowerCase();
            var adapterHtml;
            if (!url || /^none/i.test(adapter)) {
              adapterHtml = esc(adapter || 'None — BNC direct');
            } else {
              adapterHtml = '<a href="' + esc(url) + '" data-adapter-product-link>' + esc(adapter) + '</a>';
            }
            var imgHtml = '';
            if (image) {
              imgHtml =
                '<div class="adapter-guide__radio-media">' +
                '<img class="adapter-guide__radio-img" src="' +
                esc(image) +
                '" alt="' +
                esc(imageAlt) +
                '" loading="lazy" decoding="async" width="320" height="240">' +
                '</div>';
            }
            return (
              '<article class="adapter-guide__radio card-wrapper underline-links-hover' +
              (image ? ' adapter-guide__radio--has-image' : '') +
              '" role="listitem" data-search="' +
              esc(hay) +
              '">' +
              '<div class="card card--card card--text color-' +
              esc(scheme) +
              ' gradient"><div class="card__inner">' +
              imgHtml +
              '<div class="card__content"><div class="card__information">' +
              '<span class="adapter-guide__radio-badge">' +
              esc(connector || '—') +
              '</span>' +
              '<h3 class="card__heading h4">' +
              esc(brand) +
              ' ' +
              esc(model) +
              '</h3>' +
              '<p><strong>Adapter:</strong> ' +
              adapterHtml +
              '</p>' +
              (note ? '<p class="adapter-guide__radio-meta">' + esc(note) + '</p>' : '') +
              '</div></div></div></div></article>'
            );
          })
          .join('');
        grid.innerHTML = html;

        var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-search]'));
        var total = cards.length;

        grid.addEventListener('click', function (ev) {
          var a = ev.target && ev.target.closest ? ev.target.closest('a[data-adapter-product-link]') : null;
          if (!a) return;
        });

        function apply() {
          var q = (search.value || '').toLowerCase().trim();
          var shown = 0;
          for (var i = 0; i < cards.length; i++) {
            var hay = cards[i].getAttribute('data-search') || '';
            var ok = !q || hay.indexOf(q) !== -1;
            cards[i].hidden = !ok;
            if (ok) shown++;
          }
          if (countEl) countEl.textContent = 'Showing ' + shown + ' of ' + total;
          if (emptyEl) emptyEl.hidden = shown !== 0;
        }

        search.addEventListener('input', apply);
        search.addEventListener('search', apply);
        apply();
      })
      .catch(function (err) {
        if (countEl) countEl.textContent = 'Could not load radio chart';
        console.error('[adapter-guide]', err);
      });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-adapter-guide]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
